export default {
  name: "TrashIcon",
  props: {
    statusEditable: {
      type: Boolean,
      default: false
    },
    classSpan: {
      type: String,
      default: ""
    },
    classButtonWrap: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
    };
  },
  methods: {
  },
  computed: {

  }
}